import React from 'react'; 

export default function NotificationsList({ notifications }) {
  return (
    <div className=" surface-ground rounded-lg shadow-lg p-2">
    
      <div className="space-y-4">
        {notifications.map(notification => (
          <div key={notification.id} className="border-b pb-4 last:border-b-0">
            <h3 className="font-semibold text-lg">{notification.title}</h3>
            <p className="text-gray-600 mt-1">{notification.message}</p>
            <span className="text-sm text-gray-500 mt-2 block">
              {new Date(notification.date).toLocaleString()}
            </span>
          </div>
        ))}
        {notifications.length === 0 && (<span className="text-gray-500">Yeni Bildirim Yok</span>)}
      </div>
    </div>
  );
}
